import React from 'react';
import { Button, ButtonProps } from 'antd';
import { usePermissionControl } from '@/hooks/usePermissionControl';
import { ACTION_CONTROL } from '@/constants/action-permission';

interface PermissionButtonProps extends Omit<ButtonProps, 'onClick'> {
  permissionKey: ACTION_CONTROL;
  onClick: () => void;
  children: React.ReactNode;
}

/**
 * 权限按钮组件
 * 自动处理权限检查，无权限时显示错误提示
 */
const PermissionButton: React.FC<PermissionButtonProps> = ({
  permissionKey,
  onClick,
  children,
  ...buttonProps
}) => {
  const { handlePermissionClick } = usePermissionControl();

  const handleClick = () => {
    handlePermissionClick(permissionKey, onClick);
  };

  return (
    <Button {...buttonProps} onClick={handleClick}>
      {children}
    </Button>
  );
};

export default PermissionButton;
